import type { SVGProps } from "react";

export function IconVideoSeekBack(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      aria-hidden="true"
      fill="none"
      stroke="white"
      strokeWidth="1.8"
      viewBox="0 0 48 48"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>Video seek back ten seconds</title>
      <path
        d="M24 8 A16 16 0 1 1 8 24"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <polyline
        points="29,3 24,8 29,13"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <text
        dominantBaseline="middle"
        fill="white"
        fontFamily="Inter, sans-serif"
        fontSize="13"
        fontWeight="500"
        stroke="none"
        textAnchor="middle"
        x="24"
        y="26"
      >
        10
      </text>
    </svg>
  );
}
